export enum ProdRequestStatus {
  Requested = 'requested',
  Ordered = 'ordered',
  Prepared = 'prepared',
  PickedUp = 'picked_up'
}
